import Box from 'components/shared/Box'
import Grid from 'components/shared/Grid'
import { Children, cloneElement, useEffect, useState } from 'react'
import { useResolutions } from 'store/resolutions'
import { RadioTileGroupWrapper } from './RadioTileGroup.styles'
import { RadioTileGroupProps } from './RadioTileGroup.types'
import {
    RadioTileGroupItem,
    RadioTileGroupItemProps,
} from './subcomponents/RadioTileGroupItem'
import { SimpleRadioTileGroupItem } from './subcomponents/SimpleRadioTileGroupItem'

export const RadioTileGroup = ({
    children,
    value,
    label,
    name,
    isError,
    onChange,
    columns = 2,
    isExpandable = false,
    isAutoScrolling = false,
    'data-testid': testId,
}: RadioTileGroupProps) => {
    const { isTablet } = useResolutions()

    const [valueLocal, setValueLocal] = useState(value)

    useEffect(() => {
        setValueLocal(value)
    }, [value])

    const handleOnChange = (value: string) => {
        setValueLocal(value)
        onChange?.(value)
    }

    const managedChildren = Children.map(children, (child, index) => {
        const { value: childValue } = child.props as RadioTileGroupItemProps
        const isChecked =
            valueLocal !== undefined ? childValue === valueLocal : false

        return cloneElement(child, {
            name,
            isError,
            isExpandable,
            isAutoScrolling,
            isChecked,
            onChange: handleOnChange,
            'data-testid': testId ? `${testId}-${index}` : undefined,
        })
    })

    return (
        <RadioTileGroupWrapper
            data-component="RadioTileGroup"
            direction="column"
            gap={16}
            width="100%"
        >
            {!!label && (
                <Box direction="column" gap={8}>
                    {label}
                </Box>
            )}
            <Box gap={16} isFullWidth={columns < 2 || isTablet}>
                <Grid columns={columns} gap={[8, 16]} hasEvenColumns>
                    {managedChildren}
                </Grid>
            </Box>
        </RadioTileGroupWrapper>
    )
}

RadioTileGroup.displayName = 'RadioTileGroup'
RadioTileGroup.Item = RadioTileGroupItem
RadioTileGroup.Item.displayName = 'RadioTileGroup.Item'
RadioTileGroup.SimpleItem = SimpleRadioTileGroupItem
RadioTileGroup.SimpleItem.displayName = 'RadioTileGroup.SimpleItem'
